import { Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-view-valuesets',
    templateUrl: './view-valuesets.component.html',
    styleUrls: ['./view-valuesets.component.scss'],
    standalone: false
})
export class ViewValuesetsComponent implements OnInit {
  gridConfig: any = {};
  valuesetDetailGrid: any = {}
  limit:any = 10;

  constructor(public dialogConfig: DialogConfig, private baseService: BaseService) { }

  ngOnInit(): void {
    this.gridConfig.config = {
      table: true,
      tile: false,
      activeField: 'table',
      search: false,
      print_allowed: false,
      allowPagination: true
    }
    if (this.dialogConfig.data.hasOwnProperty('valueset')) {
      this.gridConfig.fields = [{
        "heading": "field.label.resource_id",
        "card_tag": null,
        "order": 1,
        "sortable": false,
        "name": "text"
      }, {
        "name": "gridButton",
        "freeze": true,
        "buttonList": [
          {
            "action": "view_details",
            "label": "button.view",
            "permission_required": false,
            "class": "btn-primary mr-1",
            "type": "button"
          }
        ]
      }]
    }
  }

  buttonAction(event) {
    console.log(event)
    let page_no = 0;
    let page_size = 10;
    if (event.actionType.action == 'view_details') {
      this.baseService.getData({ args: 'system:karexpert,resourceId:' + event.data.text }, '', 'valueset', 'system-management', 'get_valueset_by_id_flat').subscribe(res => {
        console.log(res)
        this.valuesetDetailGrid.data = res;
        this.applyPagination(res, page_no, page_size)
        this.baseService.getResourceDef('valueset_concept', (resourceDef) => {
          this.valuesetDetailGrid.fields = resourceDef.list.fields;
        })
      })
    }
  }

  applyPagination(data, page_no, page_size) {

    // console.log(data.resource.slice(page_size * page_no, page_size * (page_no + 1)))
    this.valuesetDetailGrid.dataToShow = JSON.parse(JSON.stringify(data))
    this.valuesetDetailGrid.dataToShow.resource = this.valuesetDetailGrid.dataToShow.resource.slice(page_size * page_no, page_size * (page_no + 1))
    this.valuesetDetailGrid.dataToShow = JSON.parse(JSON.stringify(this.valuesetDetailGrid.dataToShow))
  }
  onPageChanges(event) {
    console.log(event)
    this.applyPagination(this.valuesetDetailGrid.data, event-1, this.limit);
  }
  onLimitChange(event) {
    console.log(event)
   this.limit =  event.target.value
    this.applyPagination(this.valuesetDetailGrid.data, 0, event.target.value);
  }
}
